import React from 'react';
import { GridApi } from '@ag-grid-community/core';
import { CustomQuickFilter } from '../../../UiComponentsLibrary/UDC';

import {
  HeaderPanelContainer,
  PanelGroup,
  AddFilterSelector,
  FilterBar,
  ColumnManager,
  ClientSideExportButton,
  DensityDropdown,
} from '../../../UiComponentsLibrary/UDC';

interface FilterGroup {
  colId: string;
  filterName: string;
  filterComponent: React.ComponentType;
  filterComponentProps: Record<string, unknown>;
}

interface ColumnExtendedDef {
  colId: string;
  alwaysHidden: boolean;
  alwaysDisplayed: boolean;
  hideWhenResetToDefault: boolean;
}

interface ColumnManagerPreset {
  presetId: string;
  label: string;
  disabledStatus: { disabled: boolean; message: string | null };
  columns: ColumnExtendedDef[];
}

interface UDCTableHeaderPanelProps {
  filterGroups: FilterGroup[];
  columnExtendedDefs: ColumnExtendedDef[];
  columnManagerPresetDefs: ColumnManagerPreset[];
  onExport: () => void;
  bookingData: Record<string, unknown>[];
  gridApi: GridApi | null;
  onFieldFilterChange?: (field: string | null, value: string) => void;
  isExportDisabled?: boolean;
}

/**
 * Reusable header panel component for UDC tables
 */
const UDCTableHeaderPanel = ({
  filterGroups,
  columnExtendedDefs,
  columnManagerPresetDefs,
  onExport,
  bookingData,
  gridApi,
  onFieldFilterChange,
  isExportDisabled = false,
}: UDCTableHeaderPanelProps) => {
  return (
    <>
      {filterGroups.length > 0 && <FilterBar filterGroups={filterGroups} />}
      <HeaderPanelContainer>
        <PanelGroup align="start">
          <CustomQuickFilter
            data={bookingData}
            gridApi={gridApi}
            onFieldFilterChange={onFieldFilterChange}
          />
          {filterGroups.length > 0 && (
            <AddFilterSelector filterGroups={filterGroups} />
          )}
        </PanelGroup>
        <PanelGroup align="end">
          <DensityDropdown />
          <ClientSideExportButton
            onExport={onExport}
            isDisabled={() => isExportDisabled}
          />
          <ColumnManager
            columnExtendedDefs={columnExtendedDefs}
            columnManagerPresetDefs={columnManagerPresetDefs}
          />
        </PanelGroup>
      </HeaderPanelContainer>
    </>
  );
};

export default UDCTableHeaderPanel;
